let thisLogoutMixin = {
    methods: {
        unloginMeAsAdmin: function() {
            Cookies.remove('adlgn_t')
            this.$store.state.loginData.adminLoggedIn = false
        
            if (socket && socket.connected) {
                socket.emit('unloginMeAsAdmin', function() {
                    socket.disconnect()
                })
            }
        }
    }
}

export default thisLogoutMixin